import Alpine from "alpinejs";
import "../components/index.js";

console.debug("--- USING " + process.env.NODE_ENV.toUpperCase() + " BUILD ---");

window.Alpine = Alpine;
Alpine.start();